export { default } from './TwoColumnText'
